// Module
var code = "<div class=\"d-print-none single-row d-flex gap-3 justify-content-center mx-auto p-2\" ng-transclude></div> ";
// Exports
export default code;